import React from 'react';
import { Typography, Divider, Alert, Space } from 'antd';
import { InfoCircleOutlined, MailOutlined, BookOutlined, ReloadOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const HelpPradzia = () => (
    <div className="help-content">
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div>
                <Title level={2} style={{ marginBottom: 16 }}>
                    VKSIS pagalbos centras
                </Title>
                <Paragraph style={{ fontSize: 16, lineHeight: 1.8 }}>
                    Sveiki atvykę į <Text strong>Šiaulių savivaldybės švietimo įstaigų veiklos kokybės stebėsenos informacinės sistemos (VKSIS)</Text> pagalbos centrą.
                </Paragraph>
            </div>

            <Divider />

            <div>
                <Title level={3} style={{ marginBottom: 12 }}>
                    <InfoCircleOutlined style={{ marginRight: 8, color: '#fdab01' }} />
                    Apie sistemą
                </Title>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    Ši sistema skirta tam, kad mokyklos galėtų vienoje vietoje teikti Švietimo skyriui informaciją apie
                    savo veiklos rodiklius, mokinius, klases, projektus ir apklausas.
                </Paragraph>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8 }}>
                    VKSIS pakeičia ankstesnį duomenų rinkimo procesą, kai informacija buvo teikiama el. paštu,
                    &ldquo;Excel&rdquo; failais ar skirtingomis formomis – nuo šiol visi duomenys teikiami vieningoje sistemoje.
                </Paragraph>
            </div>

            <Divider />

            <div>
                <Title level={3} style={{ marginBottom: 12 }}>
                    <BookOutlined style={{ marginRight: 8, color: '#fdab01' }} />
                    Kaip naudotis pagalba
                </Title>
                <Paragraph style={{ fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                    Kairėje pusėje matote pagalbos skyrius pagal sistemos modulius – <Text strong>Mokyklų pagrindinė informacija, Mokyklų rodiklių pildymas</Text> ir kt. Pasirinkę skyrių rasite paaiškinimus, ką reiškia kiekvienas puslapis
                    ir kaip teisingai pildyti duomenis.
                </Paragraph>
            </div>

            <Alert
                message="Naršyklės talpyklos atnaujinimas"
                description={(
                    <div>
                        <Paragraph style={{ marginBottom: 8, fontSize: 14 }}>
                            Jei nematote naujausių pakeitimų ar atnaujintų skaičių, pabandykite:
                        </Paragraph>
                        <ul style={{ marginBottom: 0, paddingLeft: 20 }}>
                            <li>Atnaujinti puslapį su <Text keyboard>Ctrl + Shift + R</Text> (arba <Text keyboard>Cmd + Shift + R</Text> &ldquo;Mac&rdquo; kompiuteriuose)</li>
                            <li>Arba laikydami nuspaustą <Text keyboard>Shift</Text> klavišą paspauskite naršyklės perkrovimo <ReloadOutlined /> mygtuką</li>
                        </ul>
                    </div>
                )}
                type="info"
                icon={<ReloadOutlined />}
                showIcon
                style={{ marginBottom: 16 }} />

            <Paragraph style={{ fontSize: 15, lineHeight: 1.8, color: '#666' }}>
                <Text italic>Šis pagalbos centras yra nuolat pildomas ir atnaujinamas kartu su sistema.</Text>
            </Paragraph>

            <Divider />

            <Alert
                message="Susisiekite su mumis"
                description={(
                    <Paragraph style={{ marginBottom: 0, fontSize: 15 }}>
                        Kylant nesklandumams ar papildomiems klausimams rašykite{' '}
                        <a href="mailto:jurgita.bagdoniene@siauliai.lt" style={{ fontWeight: 500 }}>
                            <MailOutlined style={{ marginRight: 4 }} />
                            jurgita.bagdoniene@siauliai.lt
                        </a>
                    </Paragraph>
                )}
                type="warning"
                icon={<MailOutlined />}
                showIcon />
        </Space>
    </div>
);

export default HelpPradzia;
